import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/leave-rules',
    name: 'leave-rule',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/leave-rule/index.vue')
  }
]
